import { useRef, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import useOnClickOutside from 'use-onclickoutside'
import { BodySemi } from 'components/common/typography'
import Stepper from 'components/common/stepper'
import { ConditionalDiv } from 'components/common/common_styles'
import InfoPopup from 'components/common/infoPopup'
import BookingWidgetMobileDropdownMenu from './bookingWidgetMobileDropdownMenu'
import { MainContainer, AdultChildGrid, ChildCaption, Divider, DogRow, FeeRow, FeeCaption, ApplyButton } from './bookingWidgetGuestDropdown_styles'

const BookingWidgetGuestDropdown = ({ close, adultCount, setAdultCount, childCount, setChildCount, bringingDogs, setBringingDogs, adaAccessible, setAdaAccessible, $offset }) => {
  const ref = useRef()
  const { prismicRentals: { data } } = useStaticQuery(query)
  useOnClickOutside(ref, close)

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        close()
      }
    }
    document.addEventListener('keydown', onKeyDown, false)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [close])

  return (
    <MainContainer ref={ref} $offset={$offset}>
      <BookingWidgetMobileDropdownMenu title='Guests' onClose={close} />
      <div>
        <AdultChildGrid>
          <BodySemi>Adults</BodySemi>
          <Stepper count={adultCount} setCount={setAdultCount} minimum={1} maximum={8 - childCount} accessibleTitle='adult count' />
          <ChildCaption>
            Bringing more<br />than 8 people
            <InfoPopup data={data.sites_policy} altText='bringing more than 8 people info' />
          </ChildCaption>
          <div />
          <BodySemi>Children</BodySemi>
          <Stepper count={childCount} setCount={setChildCount} maximum={8 - adultCount} accessibleTitle='child count' />
          <ChildCaption>Under 12</ChildCaption>
        </AdultChildGrid>
        <Divider />
        <DogRow>
          <BodySemi as='label' htmlFor='adaAccessible'>ADA Accessible</BodySemi>
          <input type='checkbox' checked={adaAccessible} id='adaAccessible' onChange={() => setAdaAccessible(oldVal => !oldVal)} />
        </DogRow>
        <DogRow>
          <BodySemi as='label' htmlFor='bringingDogs'>Bringing Dogs?</BodySemi>
          <input type='checkbox' id='bringingDogs' checked={bringingDogs} onChange={() => setBringingDogs(oldVal => !oldVal)} />
        </DogRow>
        <FeeRow>
          <FeeCaption>Fees May Apply</FeeCaption>
          <InfoPopup data={data.dog_fee} altText='dog fee info' />
        </FeeRow>
        <ConditionalDiv mobileOnly>
          <ApplyButton $black onClick={close}>APPLY</ApplyButton>
        </ConditionalDiv>
      </div>
    </MainContainer>
  )
}

export default BookingWidgetGuestDropdown

export const query = graphql`
  query {
    prismicRentals {
      data {
        dog_fee {
          richText
        }
        sites_policy {
          richText
        }
      }
    }
  }
`
